import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l14 0","key":"svg-0"}],["path",{"d":"M15 16l4 -4","key":"svg-1"}],["path",{"d":"M15 8l4 4","key":"svg-2"}]]

/**
 * IconArrowNarrowRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbmFycm93LXJpZ2h0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDEybDE0IDAiIC8+CiAgPHBhdGggZD0iTTE1IDE2bDQgLTQiIC8+CiAgPHBhdGggZD0iTTE1IDhsNCA0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-narrow-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowNarrowRight = createReactComponent('outline', 'arrow-narrow-right', 'ArrowNarrowRight', __iconNode);

export default IconArrowNarrowRight;